import {baseAPI} from './BaseAPI';
import {AccountDeletion} from '../models/AccountDeletion';

export const accountDeletionAPI = baseAPI.injectEndpoints({
    endpoints: build => ({
        getAccountDeletion: build.query<AccountDeletion, void>({
            query: () => 'Users/me/deletion',
            providesTags: ['Auth'],
        }),
        requestAccountDeletion: build.mutation<AccountDeletion, {password: string}>({
            query: body => ({url: 'Users/me', method: 'DELETE', body}),
            invalidatesTags: (_data, error) => error ? [] : ['Auth', 'User'],
        }),
        cancelAccountDeletion: build.mutation<AccountDeletion, void>({
            query: () => ({url: 'Users/me/deletion/cancel', method: 'POST'}),
            invalidatesTags: (_data, error) => error ? [] : ['Auth', 'User'],
        }),
        downloadAccountExport: build.mutation<null, void>({
            async queryFn(_arg, _api, _options, query) {
                const result = await query({url: 'Users/me/export', responseHandler: response =>
                    response.ok ? response.blob() : response.json()});
                if (result.error) return {error: result.error};
                const url = URL.createObjectURL(result.data as Blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'bakery-account-export.zip';
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.setTimeout(() => URL.revokeObjectURL(url), 1000);
                return {data: null};
            },
        }),
    }),
});

